<template>
  <div class="main-index">
    <a-row>

     <div class="dataOverview">
        <!-- 数据概览 -->
       <a-col :span="14" >
         <div class="head">
           <h3>
             数据概览
             <a-tooltip  content="" placement="right" effect="light">
               <template slot="title">
                 <span>根据用户数据权限统计机器人总数、流程总数、执行总次数</span>
               </template>
               <i class="el-icon-warning" style="color: #3373f2;"></i>
             </a-tooltip>
           </h3>
           <span style="color: #9fb6d1">
             数据更新时间: {{updateTime}}
           </span>
         </div>
         <div class="content">
            <div class="content-data">
              <div>
                <label>
                  <animate-number from="0" to="0" duration="1000" ref="robotCount" mode="manual" style="color: #3e7af2;"></animate-number>
                </label>

                <p>机器人总数 <span>（台）</span></p>

                <img src="../assets/images/robotCount_01.png">
              </div>
            </div>
           <div class="content-data">
             <div>
               <label>
                 <animate-number from="0" to="0" duration="1000" ref="processCount" mode="manual" style="color: #ff5c10;"></animate-number>
               </label>
               <p>流程总数 <span>（个）</span></p>

               <img src="../assets/images/taskCount_02.png">

             </div>
           </div>
           <div class="content-data">
             <div>
               <label>
                 <animate-number from="0" to="0" duration="1000" ref="execTimes" mode="manual" style="color: #26a396;"></animate-number>
               </label>
               <p>执行总次数<span>（次）</span></p>

               <img src="../assets/images/execTimes_03.png">

             </div>
           </div>
         </div>
       </a-col>
       <!-- 作业概览 -->
       <a-col :span="10">
         <div class="head">
           <h3>
             作业概览
             <a-tooltip  content="" placement="right" effect="light">
               <template slot="title">
                 <span>根据用户数据权限统计当前系统等待作业、执行中作业、已完成作业数</span>
               </template>
               <i class="el-icon-warning" style="color: #3373f2;"></i>
             </a-tooltip>
           </h3>
         </div>
         <div class="content">
           <div class="content-data">
             <div>
               <img src="../assets/images/executed_icon.png">
               <span>等待</span>
             </div>

             <animate-number class="totalStatistics" from="0" to="0" duration="1000" ref="waitExec" mode="manual"></animate-number>

           </div>
           <div class="content-data">
             <div>
               <img src="../assets/images/complete.png">
               <span>执行中</span>
             </div>
             <animate-number from="0" class="totalStatistics" to="0" duration="1000" ref="executingCount" mode="manual"></animate-number>

           </div>
           <div class="content-data">

             <div>
               <img src="../assets/images/under.png">
               <span>完成</span>
             </div>
             <animate-number from="0" to="0" class="totalStatistics" duration="1000" ref="completeCount" mode="manual"></animate-number>

           </div>
         </div>
       </a-col>
     </div>


     <div class="dataEchars">

        <!-- 流程效能趋势 -->
        <a-col :span="14">
          <div class="head">
            <h3>
              流程效能趋势
              <a-tooltip  content="" placement="right" effect="light">
                <template slot="title">
                  <span>按照月份、部门、流程统计流程每日执行次数，如果未选择流程，则取部门下执行次数最多的前5个流程展示每日执行次数，流程执行状态为所有状态，根据流程执行创建时间统计</span>
                </template>
                <i class="el-icon-warning" style="color: #3373f2;"></i>
              </a-tooltip>
            </h3>
            <div>
              <a-select
                  v-model="trendTime"
                  placeholder="日期"
                  style="width: 140px;margin-right: 15px"
                  @change="searchChange($event,1)"
              >
                <a-select-option :value="$moment().format('YYYY-MM')">{{this.$moment().format("YYYY-MM")}}</a-select-option>
                <a-select-option :value="$moment().add(-1, 'M').format('YYYY-MM')">{{this.$moment().add(-1, 'M').format("YYYY-MM")}}</a-select-option>
                <a-select-option :value="$moment().add(-2, 'M').format('YYYY-MM')">{{this.$moment().add(-2, 'M').format("YYYY-MM")}}</a-select-option>
                <a-select-option :value="$moment().add(-3, 'M').format('YYYY-MM')">{{this.$moment().add(-3, 'M').format("YYYY-MM")}}</a-select-option>
                <a-select-option :value="$moment().add(-4, 'M').format('YYYY-MM')">{{this.$moment().add(-4, 'M').format("YYYY-MM")}}</a-select-option>
              </a-select>
              <a-select
                  v-model="trendOrgIds"
                  placeholder="部门"
                  style="width: 140px;margin-right: 15px"
                  allowClear
                  @change="searchChange($event,1,'部门','流程')"
              >
                <a-select-option  v-for="item in orgList" :value="item.id">{{item.name}}</a-select-option>
              </a-select>
              <a-select
                  mode="multiple"
                  @change="searchChange($event,1)"
                  v-model="trendProcessIds"
                  placeholder="流程"
                  style="width: 140px; "
                  allowClear
                  :maxTagCount="0"
                  optionFilterProp="children"
              >
                <a-select-option  v-for="item in trendTaskList" :value="item.id">{{item.name}}</a-select-option>
              </a-select>
            </div>
          </div>

          <div class="content">
            <div class="zt-nodata" v-if="trendDefaultShow">
              <span>
                暂无数据,请重新选择
              </span>
            </div>
            <div id="chart_trend" v-show="!trendDefaultShow"></div>
          </div>
        </a-col>

        <!-- 待执行总数 -->
        <a-col :span="10">
          <div class="head">
            <h3>
              等待作业列表
              <a-tooltip  content="" placement="right" effect="light">
                <template slot="title">
                  <span>展示创建时间距当前时间最近的5条等待作业</span>
                </template>
                <i class="el-icon-warning" style="color: #3373f2;"></i>
              </a-tooltip>
            </h3>

            <a-icon style="font-size: 22px;" @click="Jump('1')" v-if="$store.state.user.userInfo.roleType == 1" type="ellipsis" />
          </div>
          <div class="content">
            <a-table :columns="tableColumns" bordered :data-source="executedTableData" :loading="btnLoad" :pagination="false">
              <span slot="customTitle">创建时间</span>
              <template slot="startType" slot-scope="text">
                <span v-if="text === '手动' ">
                  <a-tag color="blue">手动</a-tag>
                </span>
                      <span v-if="text === 'API' ">
                  <a-tag color="cyan">API</a-tag>
                </span>
                      <span v-if="text === '触发器' ">
                  <a-tag color="orange">触发器</a-tag>
                </span>
                <span v-if="text === 'Robot' ">
                  <a-tag color="pink">代理启动</a-tag>
                </span>
              </template>

            </a-table>
          </div>
        </a-col>

       <!-- 机器人效能趋势 -->
        <a-col :span="14">
          <div class="head">
            <h3>
              机器人效能趋势
              <a-tooltip  content="" placement="right" effect="light">
                <template slot="title">
                  <span>统计机器人忙碌时间，比如2023-11-7，统计当天00:00:00到23:59:59某台无人值守机器人执行流程总共时间，如果有流程从早上8点到第二天2点，统计当天忙碌时间从8点到24点，后面0点到2点的算到第二天，选择机器人执行忙碌时长最长的前5个机器人展示每日忙碌时间</span>
                </template>
                <i class="el-icon-warning" style="color: #3373f2;"></i>
              </a-tooltip>
            </h3>
            <div>
              <a-select
                  v-model="effectivenessTime"
                  placeholder="日期"
                  style="width: 140px;margin-right: 15px"
                  @change="searchChange($event,2)"
              >
                <a-select-option :value="$moment().format('YYYY-MM')">{{this.$moment().format("YYYY-MM")}}</a-select-option>
                <a-select-option :value="$moment().add(-1, 'M').format('YYYY-MM')">{{this.$moment().add(-1, 'M').format("YYYY-MM")}}</a-select-option>
                <a-select-option :value="$moment().add(-2, 'M').format('YYYY-MM')">{{this.$moment().add(-2, 'M').format("YYYY-MM")}}</a-select-option>
                <a-select-option :value="$moment().add(-3, 'M').format('YYYY-MM')">{{this.$moment().add(-3, 'M').format("YYYY-MM")}}</a-select-option>
                <a-select-option :value="$moment().add(-4, 'M').format('YYYY-MM')">{{this.$moment().add(-4, 'M').format("YYYY-MM")}}</a-select-option>
              </a-select>
              <a-select
                  v-model="effectivenessOrgIds"
                  placeholder="部门"
                  style="width: 140px;margin-right: 15px"
                  allowClear
                  @change="searchChange($event,2,'部门','机器人')"
              >
                <a-select-option  v-for="item in orgList" :value="item.id">{{item.name}}</a-select-option>
              </a-select>
              <a-select
                  mode="multiple"
                  @change="searchChange($event,2)"
                  v-model="effectivenessProcessIds"
                  placeholder="机器人"
                  style="width: 140px; "
                  allowClear
                  :maxTagCount="0"
                  optionFilterProp="children"
              >
                <a-select-option  v-for="item in effectivenessTaskList" :value="item.id">{{item.name}}</a-select-option>
              </a-select>
            </div>
          </div>

          <div class="content">
            <div class="zt-nodata" v-if="effectivenessDefaultShow">
              <span>
                暂无数据,请重新选择
              </span>
            </div>
            <div id="chart_effectiveness" v-show="!effectivenessDefaultShow"></div>
          </div>


        </a-col>

       <!-- 执行中总数 -->
        <a-col :span="10">
          <div class="head">
            <h3>
              执行作业列表
              <a-tooltip  content="" placement="right" effect="light">
                <template slot="title">
                  <span>展示开始时间距当前时间最近的5条执行中作业</span>
                </template>
                <i class="el-icon-warning" style="color: #3373f2;"></i>
              </a-tooltip>
            </h3>
            <a-icon style="font-size: 22px;" @click="Jump('2')" type="ellipsis" v-if="$store.state.user.userInfo.roleType == 1" />
          </div>
          <div class="content">
            <a-table :columns="tableColumns" bordered :data-source="executionTableData" :loading="btnLoad" :pagination="false">
              <span slot="customTitle">开始时间</span>
              <template slot="startType" slot-scope="text">
                <span v-if="text === '手动' ">
                  <a-tag color="blue">手动</a-tag>
                </span>
                <span v-if="text === 'API' ">
                  <a-tag color="cyan">API</a-tag>
                </span>
                <span v-if="text === '触发器' ">
                  <a-tag color="orange">触发器</a-tag>
                </span>
                <span v-if="text === 'Robot' ">
                  <a-tag color="pink">代理启动</a-tag>
                </span>
              </template>

            </a-table>
          </div>
        </a-col>

        <a-col :span="14" class="pieCol">
          <!-- 流程执行状态 -->
          <div class="piecol-content">
            <div class="head" style="display: flex;flex-direction: column;align-items: flex-start;;">
              <h3 style="margin-bottom: 13px;">流程执行状态</h3>

              <div class="screen">
                <a-select
                    v-model="executeTime"
                    placeholder="日期"
                    @change="searchChange($event,3)"
                >
                  <a-select-option :value="$moment().format('YYYY-MM')">{{this.$moment().format("YYYY-MM")}}</a-select-option>
                  <a-select-option :value="$moment().add(-1, 'M').format('YYYY-MM')">{{this.$moment().add(-1, 'M').format("YYYY-MM")}}</a-select-option>
                  <a-select-option :value="$moment().add(-2, 'M').format('YYYY-MM')">{{this.$moment().add(-2, 'M').format("YYYY-MM")}}</a-select-option>
                  <a-select-option :value="$moment().add(-3, 'M').format('YYYY-MM')">{{this.$moment().add(-3, 'M').format("YYYY-MM")}}</a-select-option>
                  <a-select-option :value="$moment().add(-4, 'M').format('YYYY-MM')">{{this.$moment().add(-4, 'M').format("YYYY-MM")}}</a-select-option>
                </a-select>
                <a-select
                    v-model="executeOrgIds"
                    placeholder="部门"
                    allowClear
                    @change="searchChange($event,3,'部门','流程')"
                >
                  <a-select-option  v-for="item in orgList" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
                <a-select
                    mode="multiple"
                    @change="searchChange($event,3)"
                    v-model="executeProcessIds"
                    placeholder="流程"
                    :maxTagCount="0"
                    allowClear
                    optionFilterProp="children"
                >
                  <a-select-option  v-for="item in executeTaskList" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
              </div>
            </div>
            <div class="content">
              <div id="chart_execute"></div>
            </div>
          </div>
         <!-- 流程执行状态 -->
         <div class="piecol-content">
            <div class="head" style="display: flex;flex-direction: column;align-items: flex-start;">
              <h3 style="margin-bottom: 13px;">流程调用类型</h3>
              <div class="screen">
                <a-select
                    v-model="callTime"
                    placeholder="日期"
                    @change="searchChange($event,4)"
                >
                  <a-select-option :value="$moment().format('YYYY-MM')">{{this.$moment().format("YYYY-MM")}}</a-select-option>
                  <a-select-option :value="$moment().add(-1, 'M').format('YYYY-MM')">{{this.$moment().add(-1, 'M').format("YYYY-MM")}}</a-select-option>
                  <a-select-option :value="$moment().add(-2, 'M').format('YYYY-MM')">{{this.$moment().add(-2, 'M').format("YYYY-MM")}}</a-select-option>
                  <a-select-option :value="$moment().add(-3, 'M').format('YYYY-MM')">{{this.$moment().add(-3, 'M').format("YYYY-MM")}}</a-select-option>
                  <a-select-option :value="$moment().add(-4, 'M').format('YYYY-MM')">{{this.$moment().add(-4, 'M').format("YYYY-MM")}}</a-select-option>

                </a-select>
                <a-select
                    v-model="callOrgIds"
                    placeholder="部门"
                    allowClear
                    @change="searchChange($event,4,'部门','流程')"
                >
                  <a-select-option  v-for="item in orgList" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
                <a-select
                    mode="multiple"
                    @change="searchChange($event,4)"
                    v-model="callProcessIds"
                    placeholder="流程"
                    allowClear
                    :maxTagCount="0"
                    optionFilterProp="children"
                >
                  <a-select-option  v-for="item in callTaskList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
              </div>
            </div>
            <div class="content">
              <div id="chart_call"></div>
            </div>
          </div>
       </a-col>

        <!-- 完成作业列表 -->
       <a-col :span="10" style="margin-bottom: 0px;">
         <div class="head">
           <h3>
             完成作业列表
             <a-tooltip  content="" placement="right" effect="light">
               <template slot="title">
                 <span>根据结束时间距当前时间最近的5条已完成的作业，包含成功、失败、已停止</span>
               </template>
               <i class="el-icon-warning" style="color: #3373f2;"></i>
             </a-tooltip>
           </h3>
           <a-icon style="font-size: 22px;" type="ellipsis" @click="Jump('3')" v-if="$store.state.user.userInfo.roleType == 1"  />

         </div>
         <div class="content">
           <a-table :columns="tableColumns" bordered :data-source="completedTableData" :loading="btnLoad" :pagination="false">
             <span slot="customTitle">结束时间</span>
             <template slot="startType" slot-scope="text">
              <span v-if="text === '手动' ">
                <a-tag color="blue">手动</a-tag>
              </span>
               <span v-if="text === 'API' ">
                <a-tag color="cyan">API</a-tag>
              </span>
               <span v-if="text === '触发器' ">
                <a-tag color="orange">触发器</a-tag>
              </span>
               <span v-if="text === 'Robot' ">
                  <a-tag color="pink">代理启动</a-tag>
                </span>
             </template>

           </a-table>
         </div>
       </a-col>

     </div>
    </a-row>
  </div>
</template>

<script>
import * as echarts from "echarts";
import sw from "element-ui/src/locale/lang/sw";
import store from "@/store";
export default {
  data() {
    return {
      // 表格lodaing
      btnLoad:false,
      // 导航数据
      navigationData: {
        robotCount: "",
        processCount: "",
        executingCount: "",
        completeCount: "",
        execTimes: "",
        waitExec: "",
      },

      // 数据视图
      chart_trend: "", // 流程效能趋势
      chart_effectiveness: "", // 机器人效能趋势
      chart_execute: "", // 流程执行状态
      chart_call: "", // 流程调用类型

      // API
      chartExecuteApi: "/index/getProcessExecState",
      chartEffectivenessApi: "index/getRobotEffectTrend",
      chartCallApi: "/index/getProcessCallType",
      chartTrendApi: "/index/getProcEffectTrend",


      switchValue: 3,

      // 流程
      taskId:undefined,


      tableColumns: [
        {
          title: '流程',
          dataIndex: 'processName',
          key: 'processName',
          ellipsis: true,
        },
        {
          dataIndex: "time",
          key: "time",
          slots: { title: 'customTitle' },
          scopedSlots: { customRender: 'time' },
          ellipsis: true,


        },
        {
          title: "启动方式",
          key: "startType",
          scopedSlots: { customRender: "startType" },
          dataIndex: "startType",
          ellipsis: true,
        },
        {
          title: '部门',
          dataIndex: 'orgName',
          key: 'orgName',
          ellipsis: true,
        },
      ],
      // 待执行任务
      executedTableData: [],
      // 执行中任务
      executionTableData: [],
      // 执行完成任务
      completedTableData: [],

      // 部门下拉框
      orgList:[],
      // 流程下拉框
      trendTaskList:[], // -效能趋势
      effectivenessTaskList:[],// -机器人效能趋势
      executeTaskList:[],// -流程执行状态
      callTaskList:[], // -流程调用类型

      // 流程效能趋势
      trendTime:this.$moment().format("YYYY-MM"),
      trendOrgIds:undefined,
      trendProcessIds:[],

      // 机器人效能趋势
      effectivenessTime:this.$moment().format("YYYY-MM"),
      effectivenessOrgIds:undefined,
      effectivenessProcessIds:[],

      // 流程执行状态
      executeTime:this.$moment().format("YYYY-MM"),
      executeOrgIds:undefined,
      executeProcessIds:[],

      // 流程调用类型
      callTime:this.$moment().format("YYYY-MM"),
      callOrgIds:undefined,
      callProcessIds:[],


      // 更新时间
      updateTime:'--',

      // 缺省图显隐
      trendDefaultShow:false,
      effectivenessDefaultShow:false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.chartsRender();
    }, 20)
    // 导航数据
    this.navigationList();
    this.taskTableUnify();
    this.allOrgList();

  },
  methods: {


    // 日期切换
    searchChange(val,state,title,echarts){




      if (title == '部门'){

        switch (echarts){
          case '流程' :
            this.axios
                .post("/process/findProcess", {orgId:val})
                .then((res) => {
                  if (res.code === 200) {
                    switch (state) {
                      case 1:
                        // 流程效能趋势
                        this.trendTaskList = res.data
                        break
                      case 3:
                        // 流程执行状态
                        this.executeTaskList =  res.data
                        break
                      case 4:
                        // 流程调用类型
                        this.callTaskList =  res.data
                        break

                    }
                    // 判断不传部门id时,流程处理为空
                    if (!val){
                      switch (state) {
                        case 1:
                          // 流程效能趋势
                          this.trendTaskList = []
                          break
                        case 3:
                          // 流程执行状态
                          this.executeTaskList = []
                          break
                        case 4:
                          // 流程调用类型
                          this.callTaskList = []
                          break
                      }
                    }
                  }
                })
                .catch((err) => {
                  console.log(err);
                });

            break
          case '机器人' :
            this.axios
                .post("robot/findRobot", {orgId:val})
                .then((res) => {
                  if (res.code === 200) {
                    switch (state) {
                      case 2:
                        // 机器人效能趋势
                        this.effectivenessTaskList = res.data
                        break
                    }
                    // 判断不传部门id时,流程处理为空
                    if (!val){
                      switch (state) {
                        case 2:
                          // 机器人效能趋势
                          this.effectivenessTaskList = []
                          break
                      }
                    }
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            break
        }

        switch (state) {
          case 1:
            // 流程效能趋势
            this.trendProcessIds = []
            break
          case 2:
            // 机器人效能趋势
            this.effectivenessProcessIds = []
            break
          case 3:
            // 流程执行状态
            this.executeProcessIds = []
            break
          case 4:
            // 流程调用类型
            this.callProcessIds = []
            break
        }

      }

      switch (state) {
        case 1:
          // 流程效能趋势
          this.chart_trend = this.echartInit("chart_trend");
          this.echartSet("chart_trend", this.chartTrendApi, this.trendTime,this.trendOrgIds,this.trendProcessIds);
          break
        case 2:
          // 机器人效能趋势
          this.chart_effectiveness = this.echartInit("chart_effectiveness");
          this.echartSet("chart_effectiveness", this.chartEffectivenessApi, this.effectivenessTime,this.effectivenessOrgIds,this.effectivenessProcessIds,'机器人');
          break
        case 3:
          // 流程执行状态
          this.chart_execute = this.echartInit("chart_execute");
          this.echartSet("chart_execute", this.chartExecuteApi, this.executeTime,this.executeOrgIds,this.executeProcessIds);
          break
        case 4:
          // 流程调用类型
          this.chart_call = this.echartInit("chart_call");
          this.echartSet("chart_call", this.chartCallApi, this.callTime,this.callOrgIds,this.callProcessIds);
          break
      }
    },
    // echarts初始化
    echartInit(domId) {
      return echarts.init(document.getElementById(domId));
    },
    //数据图重载
    chartsRender() {
      // 流程效能趋势
      this.chart_trend = this.echartInit("chart_trend");
      this.echartSet("chart_trend", this.chartTrendApi, this.trendTime,this.trendOrgIds,this.trendProcessIds);
      // 机器人效能趋势
      this.chart_effectiveness = this.echartInit("chart_effectiveness");
      this.echartSet("chart_effectiveness", this.chartEffectivenessApi, this.effectivenessTime,this.effectivenessOrgIds,this.effectivenessProcessIds,'机器人');

      // 流程执行状态
      this.chart_execute = this.echartInit("chart_execute");
      this.echartSet("chart_execute", this.chartExecuteApi, this.executeTime,this.executeOrgIds,this.executeProcessIds);

      // 流程调用类型
      this.chart_call = this.echartInit("chart_call");
      this.echartSet("chart_call", this.chartCallApi, this.callTime,this.callOrgIds,this.callProcessIds);


    },
    // echarts导入数据
    echartSet(id, api, date, orgIds, processIds,title) {
      this.axios
          .post(api,title == '机器人' ? {date:date,robotIds:processIds,orgId:orgIds} : {date:date,processIds:processIds,orgId:orgIds} )
          .then((res) => {
            let tempData = res.data,
                axisData = [],
                v1 = [],
                v2 = [],
                v3 = [],
                v4 = [],
                xData = '',
                legendData = [],
                series = [],
                areaStyle = [],
                itemStyle = [];
            switch (id) {
              case "chart_execute":
                axisData = [
                  {
                    name: "成功",
                    value: tempData.successCount,
                    itemStyle: { color: "#56bd5a" },
                  },
                  {
                    name: "已停止",
                    value: tempData.stopCount,
                    itemStyle: { color: "#c89700" },
                  },
                  {
                    name: "失败",
                    value: tempData.failCount,
                    itemStyle: { color: "#fd5044" },
                  },
                ];
                this[id].clear()
                this[id].setOption({
                  tooltip: {
                    trigger: "item",
                  },
                  legend: {
                    x:'center',
                    y:'bottom',
                    icon: "pin",
                    type: "scroll",
                    itemGap: 20,
                    padding:[0,0,60,0],
                  },
                  series: [
                    {
                      name: "状态",
                      type: "pie",
                      radius: ["55%", "35%"],
                      avoidLabelOverlap: false,
                      center: ["50%", "38%","50%","50%"],
                      label: {
                        show: false,
                        position: "center",
                      },
                      emphasis: {
                        label: {
                          show: true,
                          fontSize: "20",
                          fontWeight: "bold",
                        },
                      },
                      labelLine: {
                        show: false,
                      },
                      data: axisData,
                    },
                  ],
                });
                break;
              case "chart_effectiveness":
                if (tempData){
                  this.effectivenessDefaultShow = false
                  xData = tempData.time
                  itemStyle = ['#3373f2','#14d78f','#8e74fa','#fd798e','#f9c616'],
                      areaStyle = [
                        {
                          color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                              {
                                offset: 0,
                                color: "rgba(138, 174, 247,0.5)", // 0% 处的颜色
                              },
                              {
                                offset: 1,
                                color: "rgba(229, 242, 255)", // 100% 处的颜色
                              },
                            ],
                            global: false, // 缺省为 false
                          },
                        },
                        {
                          color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                              {
                                offset: 0,
                                color: "rgba(187, 232, 203, 0.5)", // 0% 处的颜色
                              },
                              {
                                offset: 1,
                                color: "rgba(245, 252, 247, 0)", // 100% 处的颜色
                              },
                            ],
                            global: false, // 缺省为 false
                          },
                        },
                        {
                          color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                              {
                                offset: 0,
                                color: "rgba(155, 149, 201, 0.5)", // 0% 处的颜色
                              },
                              {
                                offset: 1,
                                color: "rgba(155, 149, 201, 0)", // 100% 处的颜色
                              },
                            ],
                            global: false, // 缺省为 false
                          },
                        },
                        {
                          color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                              {
                                offset: 0,
                                color: "rgba(253, 221, 228, 0.5)", // 0% 处的颜色
                              },
                              {
                                offset: 1,
                                color: "rgba(255, 246, 248, 0)", // 100% 处的颜色
                              },
                            ],
                            global: false, // 缺省为 false
                          },
                        },
                        {
                          color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                              {
                                offset: 0,
                                color: "rgba(245, 130, 32, 0.5)", // 0% 处的颜色
                              },
                              {
                                offset: 1,
                                color: "rgba(254, 220, 189, 0)", // 100% 处的颜色
                              },
                            ],
                            global: false, // 缺省为 false
                          },
                        },
                      ]
                  for (let i = 0; i < tempData.data.length; i++) {
                    legendData.push(tempData.data[i].name)
                    series.push({
                      data: tempData.data[i].value,
                      type: "line",
                      name:tempData.data[i].name,
                      smooth: true,
                      areaStyle:areaStyle[i],
                      itemStyle:{
                        color:itemStyle[i]
                      }
                    })
                  }
                }else{
                  this.effectivenessDefaultShow = true
                }


                this[id].clear()
                this[id].setOption({
                  tooltip: {
                    trigger: "axis",
                    formatter: (p) => {
                      let str = `<span>${p[0].name}</span></br><div style="font-size: 12px; text-shadow: '0 0 1px #006DFF';text-align:left; "> `
                      p.forEach((item,index)=>{
                        str += `<span style="color:${item.color};font-size:20px;">●</span><strong style="margin:0 15px 0 5px">${ item.seriesName.length>10 ?item.seriesName.slice(0,10)+'...' : item.seriesName}</strong> <strong style="float: right;padding-top: 3px">${ item.value}</strong></br>`
                      })
                      return  str+`</div>`
                    },

                  },
                  grid: {
                    left: "1%",
                    right: "1%",
                    top: "10%",
                    bottom: "17%",
                    containLabel: true,
                  },
                  legend: {
                    formatter: function (name) {
                      return name.length > 8 ? name.substr(0, 10) + '...' : name
                    },
                    data: legendData,
                    bottom: 11,
                    itemGap: 30,
                  },
                  xAxis: {
                    type: "category",
                    axisLine: {
                      lineStyle: {
                        color: "#d7dde4",
                        width: 2,
                      },
                    },
                    axisTick: {
                      // alignWithLabel: true
                      lineStyle: {
                        color: "#d7dde4",
                      },
                    },
                    // boundaryGap: false,
                    data: xData,
                    axisLabel: {
                      // rotate: -18
                      color: "#6e7079",
                      formatter: function (v, i) {
                        if (v.length > 10) {
                          return v.substr(0, 4) + "\n" + v.substr(4, 8) + "…";
                        }
                        if (v.length > 5) {
                          return v.substr(0, 4) + "\n" + v.substr(4);
                        }
                        return v;
                      },
                    },
                  },
                  yAxis: {
                    type: "value",
                    name: "分钟",
                    minInterval: 1,
                    nameTextStyle: {
                      padding:[20,10,0,20]
                    },

                    splitLine: {
                      lineStyle: {
                        type: "dashed",
                      },
                    },
                  },
                  series: series
                });
                break;
              case "chart_call":
                console.log(tempData)
                axisData = [
                  {
                    name: "手动启动",
                    value: tempData.manualCount,
                    itemStyle: { color: "#3373f2  " },
                  },
                  {
                    name: "触发器启动",
                    value: tempData.triggerCount,
                    itemStyle: { color: "#ff8049" },
                  },
                  {
                    name: "API启动",
                    value: tempData.apiCount,
                    itemStyle: { color: "#12c1c1" },
                  },
                  {
                    name: "代理启动",
                    value: tempData.robotCount,
                    itemStyle: { color: "#ba50aa" },
                  },
                ];
                this[id].clear()
                this[id].setOption({
                  tooltip: {
                    trigger: "item",
                  },
                  legend: {
                    x:'center',
                    y:'bottom',
                    icon: "pin",
                    type: "scroll",
                    itemGap: 20,
                    padding:[0,0,60,0],
                  },
                  series: [
                    {
                      name: "状态",
                      type: "pie",
                      radius: ["55%", "35%"],
                      avoidLabelOverlap: false,
                      center: ["50%", "38%","50%","50%"],
                      label: {
                        show: false,
                        position: "center",
                      },
                      emphasis: {
                        label: {
                          show: true,
                          fontSize: "20",
                          fontWeight: "bold",
                        },
                      },
                      labelLine: {
                        show: false,
                      },
                      data: axisData,
                    },
                  ],
                });
                break;
              case "chart_trend":
                if (tempData){
                  this.trendDefaultShow = false
                  xData = tempData.time
                  itemStyle = ['#3373f2','#14d78f','#8e74fa','#fd798e','#f9c616'],
                      areaStyle = [
                        {
                          color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                              {
                                offset: 0,
                                color: "rgba(138, 174, 247,0.5)", // 0% 处的颜色
                              },
                              {
                                offset: 1,
                                color: "rgba(229, 242, 255)", // 100% 处的颜色
                              },
                            ],
                            global: false, // 缺省为 false
                          },
                        },
                        {
                          color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                              {
                                offset: 0,
                                color: "rgba(187, 232, 203, 0.5)", // 0% 处的颜色
                              },
                              {
                                offset: 1,
                                color: "rgba(245, 252, 247, 0)", // 100% 处的颜色
                              },
                            ],
                            global: false, // 缺省为 false
                          },
                        },
                        {
                          color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                              {
                                offset: 0,
                                color: "rgba(155, 149, 201, 0.5)", // 0% 处的颜色
                              },
                              {
                                offset: 1,
                                color: "rgba(155, 149, 201, 0)", // 100% 处的颜色
                              },
                            ],
                            global: false, // 缺省为 false
                          },
                        },
                        {
                          color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                              {
                                offset: 0,
                                color: "rgba(253, 221, 228, 0.5)", // 0% 处的颜色
                              },
                              {
                                offset: 1,
                                color: "rgba(255, 246, 248, 0)", // 100% 处的颜色
                              },
                            ],
                            global: false, // 缺省为 false
                          },
                        },
                        {
                          color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                              {
                                offset: 0,
                                color: "rgba(245, 130, 32, 0.5)", // 0% 处的颜色
                              },
                              {
                                offset: 1,
                                color: "rgba(254, 220, 189, 0)", // 100% 处的颜色
                              },
                            ],
                            global: false, // 缺省为 false
                          },
                        },
                      ]
                  for (let i = 0; i < tempData.data.length; i++) {
                    legendData.push(tempData.data[i].name)
                    series.push({
                      data: tempData.data[i].value,
                      type: "line",
                      name:tempData.data[i].name,
                      smooth: true,
                      areaStyle:areaStyle[i],
                      itemStyle:{
                        color:itemStyle[i]
                      }

                    })
                  }
                }else{
                  this.trendDefaultShow = true
                }


                this[id].clear()
                this[id].setOption({
                  tooltip: {
                    trigger: "axis",
                    formatter: (p) => {
                      let str = `<span>${p[0].name}</span></br><div style="font-size: 12px; text-shadow: '0 0 1px #006DFF';text-align:left; "> `
                      p.forEach((item,index)=>{
                        str += `<span style="color:${item.color};font-size:20px;">●</span><strong style="margin:0 15px 0 5px">${ item.seriesName.length>10 ?item.seriesName.slice(0,10)+'...' : item.seriesName}</strong> <strong style="float: right;padding-top: 3px">${ item.value}</strong></br>`
                      })
                      return  str+`</div>`
                    },
                  },
                  grid: {
                    left: "1%",
                    right: "1%",
                    top: "10%",
                    bottom: "17%",
                    containLabel: true,
                  },
                  legend: {
                    formatter: function (name) {
                      return name.length > 8 ? name.substr(0, 10) + '...' : name
                    },
                    data: legendData,
                    bottom: 11,
                    itemGap: 30,
                  },
                  xAxis: {
                    type: "category",
                    axisLine: {
                      lineStyle: {
                        color: "#d7dde4",
                        width: 2,
                      },
                    },
                    axisTick: {
                      // alignWithLabel: true
                      lineStyle: {
                        color: "#d7dde4",
                      },
                    },
                    // boundaryGap: false,
                    data: xData,
                    axisLabel: {
                      // rotate: -18
                      color: "#6e7079",
                      formatter: function (v, i) {
                        if (v.length > 10) {
                          return v.substr(0, 4) + "\n" + v.substr(4, 8) + "…";
                        }
                        if (v.length > 5) {
                          return v.substr(0, 4) + "\n" + v.substr(4);
                        }
                        return v;
                      },
                    },
                  },
                  yAxis: {
                    type: "value",
                    name: "次数",
                    minInterval: 1,
                    nameTextStyle: {
                      padding:[20,10,0,20]
                    },

                    splitLine: {
                      lineStyle: {
                        type: "dashed",
                      },
                    },
                  },
                  series: series
                });
                break;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 导航条数据
    navigationList(type) {
      this.axios
          .post("index/getCount")
          .then((res) => {
            if (res.code === 200) {
              this.updateTime = res.data.updateTime
              this.$refs.robotCount.reset(0, res.data.robotCount);
              this.$refs.robotCount.start();
              this.$refs.processCount.reset(0, res.data.processCount);
              this.$refs.processCount.start();
              this.$refs.executingCount.reset(0, res.data.executingCount);
              this.$refs.executingCount.start();
              this.$refs.completeCount.reset(0, res.data.completeCount);
              this.$refs.completeCount.start();
              this.$refs.waitExec.reset(0, res.data.waitExec);
              this.$refs.waitExec.start();
              this.$refs.execTimes.reset(0, res.data.execTimes);
              this.$refs.execTimes.start();
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 任务表格
    taskTableUnify(){
      this.tableList(1)
      this.tableList(2)
      this.tableList(3)
    },
    tableList(val){
      let api = ''
      switch (val) {
        case 1 :
          api = 'index/getWaitTable'
          break;
        case 2 :
          api = 'index/getExecutingTable'
          break;
        case 3 :
          api = 'index/getCompleteTable'
          break;
      }
      this.axios
          .post(api)
          .then((res) => {
            if (res.code === 200) {
              switch (val) {
                case 1 :
                  this.executedTableData = res.data
                  break;
                case 2 :
                  this.executionTableData = res.data
                  break;
                case 3 :
                  this.completedTableData = res.data
                  break;
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 部门下拉框
    allOrgList(val){
      this.axios
      .post("/org/findParentOrg",)
      .then((res) => {
        if (res.code === 200) {
          this.orgList = res.data
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },

    // 表格跳转
    Jump(val){
      this.$emit("open", val,'工作台');
    }

  },
  beforeMount() {
    console.log(this.$store.state.user)
  }
}
</script>
<style lang="scss" scoped>
.main-index {
  padding: 14px;
  height: calc(100vh - 66px);
  overflow: auto;
  // 时间切换
  .dateSwitch {
    position: absolute;
    left: 215px;
    top: 8px;
    span{
      //font-weight: 600;
      letter-spacing: 1px;
      margin-bottom: 0em;
      font-size: 15px;
      margin-right: 10px;
    }
  }

  .ant-row{
    .dataOverview{
      .ant-col{
        //height: 115px;

        .content{
          //padding: 3px 10px 0;
          display: flex;
          width: 100%;
        }
      }
      .ant-col:nth-child(1){
        span{
          //color: #9fb6d1;
          margin-top: -14px;
        }

        .content{
          .content-data{
            width: 34%;
            display: flex;
            padding: 15px ;
            margin-right: 15px;
            border-radius: 4px;
            img{
              width: 60px;
              height: 60px;
              position: absolute;
              right: 0px;
              bottom: -2px;
            }
            div{
              label{
                 display: inline-block;
                 margin: -5px 5px 0 0  ;
                 span{
                   font-weight: bold;
                   font-size: 26px;
                   margin: -5px 5px 0px 0;
                 }

              }
              p{
                margin: 4px 0px 0px 0px;
                font-weight: 600;
              }
              //span{
              //  color: #9fb6d1;
              //  font-size: 12px;
              //}
            }

          }
          .content-data:nth-child(1){
            background-color: #f2f4fb;
            position: relative;

          }
          .content-data:nth-child(2){
            background-color: #fbeaea;
            position: relative;

          }
          .content-data:nth-child(3){
            background-color: #e5f3f2;
            margin-right: 0px;
            position: relative;
            img{
              bottom: 1px;
            }
          }

          .content-data:hover{
            box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.07), 0 1px 10px 0 rgba(0, 0, 0, 0.06);
            background-color: #ffffff;
            transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
          }
        }
      }
      .ant-col:nth-child(2){
        .content{
          padding-top: 15px;
        }
        .content-data{

          width: 34%;
          display: flex;
          flex-direction: column;

          div{
            display: flex;
            align-items: center;
            margin-top: 2px;
            img{
              width: 32px;
              height: 32px;
              margin-right: 10px;
            }
          }
          .totalStatistics{
            font-weight: bold;
            font-size: 26px;
            text-align: left;
            margin-left: 7px;
          }
        }
        .content-data{
          margin-left: 15px;
        }
      }
    }


    .dataEchars{
      .ant-col{
        height: 338px;

         .content {
          ::v-deep .ant-table {
            .ant-table-thead > tr > th, .ant-table-tbody > tr > td{
              padding: 11.3px 16px;
            }
          }
          #chart_effectiveness {
            width: 100%;
            height: 290px;
          }

          #chart_execute {
            width: 100%;
            height: 290px;
          }

          #chart_call {
            width: 100%;
            height: 290px;
          }

          #chart_trend {
            width: 100%;
            height: 290px;
          }
        }
      }
    }


    .ant-col{
      margin: 0 15px 15px 0;
      background-color: #fff;
      border-radius: 4px;
      padding: 15px;
      .head{
        display: flex;
        justify-content: space-between;
        align-items: center;
          h3{
            font-weight: bold;
          }
        .screen{
          width: 100%;
          .ant-select{
            width: 32%;
            margin-right: 2%;
          }
          .ant-select:last-child{
            margin-right: 0px;
            .ant-select-selection__rendered{
              margin-bottom: -1px;
            }
          }
        }
      }

    }
    .pieCol{
      display: flex;
      padding: 0;
      background-color: transparent;
      .piecol-content{
        width: 50%;
        background-color: #ffffff;
        padding: 15px;
      }
      .piecol-content:nth-child(1){
        margin-right: 7.5px;
      }
      .piecol-content:nth-child(2){
        margin-left: 7.5px;
      }
    }
    .ant-col-10{
      width: 40.4%;
      margin-right: 0px;
      height: 150px;
    }
    .ant-col-7{
      margin-bottom: 0px;
    }
  }

  .zt-nodata {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background: url('../assets/images/no_data.png') no-repeat;
    height: 240px;
    background-position: center;
  }
 ::v-deep  .ant-empty-normal{
    margin: 63px 0;
  }
}
</style>
